module.exports = __webpack_public_path__ + "media/images/banner-assets/zh-tw/banner4-80fd009ffb4ec8090d16d98f48ed7b6a.jpg";